import { useMutation, useQueryClient } from 'react-query';
import { useToast } from '@razorpay/blade/components';
import { createFormulaCardTypeMapping } from 'api/gql-utils/overtime/mutations';
import type { CreateFormulaCardTypeMappingInput } from 'api/gql-utils/overtime/types';
import { parseError } from 'utils/Api';
import { AppError } from 'utils/AppError';
import { OT_FORMULA_CARD_TYPE_MAPPINGS_QUERY_KEY } from './useOtFormulaCardTypeMappings';

export function useCreateFormulaCardTypeMapping() {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: (input: CreateFormulaCardTypeMappingInput) =>
      createFormulaCardTypeMapping({ input }),
    onSuccess: () => {
      queryClient.invalidateQueries([OT_FORMULA_CARD_TYPE_MAPPINGS_QUERY_KEY]);
    },
    onError: (error: typeof AppError) => {
      toast.show({
        content: parseError(error),
        color: 'negative',
      });
    },
  });
}
